const user_admin = ["admin@urbanice.app","u15833112736235094", "u16024699849533371", "u16741097775772792", "u17120315335317183", "u17055527296566723"];
//admin@urbanice.app 
//u16024699849533371 = pmc.ton@test.com
//u17120315335317183 = admin.touch@test.com
//u16741097775772792 = pmc1@moon.com 
//u15833112736235094 = pmc2@moon.com
//u17055527296566723 = bell38-74@hotmail.com(Bell URB)

const user_sales = ["pmc3@test.com","u17097155592229500","u17097121603302793", "u17120444079073526", "u17085109322905261"];
//pmc3@test.com
//u17097155592229500 = ratree@thelivingos.com(Rung)
//u17120444079073526 = thanundorn@thelivingos.com(Yok)
//u17097121603302793 = phatcharapol@thelivingos.com(Pipe)
//u17085109322905261 = jirat@thelivingos.com(Mick)

const user_sales_co = ["u17186800385617048"];
//u17186800385617048 = nisanad.v@thelivingos.com(Ying)

const user_cs = ["u17186814542922603","u17186806018327971","u17187700741851139","u17186809603158208","u17186809878344822"];
//u17186814542922603 = rungtippawan.b@thelivingos.com(Bell)
//u17186806018327971 = kawinwach.k@thelivingos.com(Mon)
// arisra.t@thelivingos.com
//u17186809878344822= jiraput.p@thelivingos.com
//u17186809603158208 =  wisarut.l@thelivingos.com
//u17187700741851139 = juthamas.p@thelivingos.com

const user_finance = ["u15989591378881476","u17186900322549968"];
//u15989591378881476 = pmc4@moon.com
//u17186900322549968 = thitival.h@thelivingos.com(Mauy)

const user_marketer = ["u17186798109161229"];
//u17186798109161229 = rawee.b@thelivingos.com(Tong)

export {  
    user_admin, 
    user_sales,
    user_sales_co,
    user_finance,
    user_cs,
    user_marketer,
}